var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-plus",
    clipPath: "url(#clip0_15619_18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3334 17.7187V16.0521C13.3334 15.168 12.9822 14.3202 12.3571 13.6951C11.7319 13.0699 10.8841 12.7187 10 12.7187H4.16671C3.28265 12.7187 2.43481 13.0699 1.80968 13.6951C1.18456 14.3202 0.833374 15.168 0.833374 16.0521V17.7187M16.6667 6.88542V11.8854M19.1667 9.38542H14.1667M10.4167 6.05208C10.4167 7.89303 8.92432 9.38542 7.08337 9.38542C5.24242 9.38542 3.75004 7.89303 3.75004 6.05208C3.75004 4.21113 5.24242 2.71875 7.08337 2.71875C8.92432 2.71875 10.4167 4.21113 10.4167 6.05208Z",
    stroke: "#0B5DCF",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15619_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.21875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/userPlus.620c7179bd0ae6d8db06eeae22a12a19.svg";
export { ForwardRef as ReactComponent };